<template>
    <div class="custApp">
        <!-- <div class="sysName dots">{{ sysName }}</div> -->
        <div class="bannerWrap">
            <el-carousel :interval="5000" arrow="always" height="200px">
                <el-carousel-item v-for="(n,i) in banners" :key="i">
                    <div class="bannerItem" :style="'background-image: url('+n.img+')'"></div>
                </el-carousel-item>
            </el-carousel>
        </div>

        <div class="cpConWrap">
            <div class="orderNoticeBar" v-if="unfinishedOrderCount > 0" @click="navTo('/cust/spt/consult_guest_order?tab='+unfinishedOrder.status)">
                <el-image class="orderAvatar" fit="cover" :src="unfinishedOrder.hostHead?(fileHost+unfinishedOrder.hostHead):'/static/images/cust/mineHead.png'" ></el-image>
                <div class="orderNoticeLeft">
                    <div class="orderStatus">
                        <span class="statusDot" :style="{ backgroundColor: unfinishedOrder.status === 1 ? '#e6a23c' : '#077cf5' }"></span>
                        {{ unfinishedOrder.statusFmt }}
                    </div>
                    <div class="orderInfo">{{ unfinishedOrder.schDateFmt }} {{ unfinishedOrder.schPeriodFmt }} · {{ unfinishedOrder.hostName }} · {{ unfinishedOrder.orderTypeFmt }}</div>
                </div>
                <div class="orderNoticeRight">
                    <span v-if="unfinishedOrderCount > 1" class="orderBadge">{{ unfinishedOrderCount }}条待处理</span>
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>

            <div class="noticeBar">
                <i class="el-icon-news"></i>
                <div class="noticeTxt dots" @click="navTo('/cust/mine/notice')">公告通知</div>
                <i class="el-icon-arrow-right"></i>
            </div>

            <div class="jg1Box">
                <div class="jr1b" v-for="(n,i) in jg1Arr" :key="i" :style="'background-image: url('+n.img+')'" @click="navTo(n.path)">
                    <div class="jr1bTxt">{{ n.name }}</div>
                </div>
            </div>

            <div class="jg2Box">
                <div class="jg2Item" v-for="(n,i) in jg2Arr" :key="i" @click="navTo(n.path)">
                    <div class="jg2IconWrap" :style="'background-color:'+n.color+';'">
                        <i class="iconfont jg2Icon" v-html="n.icon"></i>
                        <span v-if="n.path === '/cust/spt/spt_portal' && sptPendingCount > 0" class="pendingBadge"></span>
                    </div>
                    <div class="jg2Name">{{ n.name }}</div>
                </div>
            </div>

            <div class="docBox">
                <div class="docTop">
                    <div class="dtTxt">热门阅读</div>
                    <div class="dtMore" @click="navTo('/mod/resource_portal')">更多<i class="iconfont">&#xe631;</i></div>
                </div>
                <div class="dtItem" v-for="(n,i) in docList" :key="i" @click="navDocDetail(n)">
                    <el-image class="dtCover" :src="fileHost+n.coverPic" fit="cover"></el-image>
                    <div class="dtInfo">
                        <div class="dtTit">{{ n.title }}</div>
                        <div class="dtTime">{{ n.createTimeFmt }}</div>
                    </div>
                </div>
            </div>
        </div>

        <tabBar></tabBar>

        <el-dialog :title="centerDialogTit" :custom-class="dialogClass" :width="centerDialogWidth" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" :visible.sync="centerDialogVisible" :fullscreen="centerDialogFs"
            v-if="centerDialogVisible" append-to-body>
            <component :is="centerComp.con" :key="centerComp.ts" :param="centerComp.param" @closeCallback="centerDialogVisible=false" @confirmCallback="centerConfirmCallback"></component>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "index",
    components: {},
    data () {
        return {
            sysName: config.sysName,
            fileHost: config.fileHost,
            uid: '',
            type: '',
            banners: [
                {
                    img: '/static/images/cust/banner1.jpg',
                },
                {
                    img: '/static/images/cust/banner2.jpg',
                }
            ],

            unfinishedOrder: null,
            unfinishedOrderCount: 0,
            pendingTimer: null,

            jg1Arr: [],
            jg1Arr_21: [
                {
                    img: '/static/images/cust/jg1_0.jpg',
                    path: '/asmt/index',
                    name: '心理测评',
                },
                {
                    img: '/static/images/cust/jg1_1.jpg',
                    path: '/mod/resource_portal',
                    name: '心灵驿站',
                },
            ],
            jg1Arr_31: [
                // {
                //     img: '/static/images/cust/jg1_0.jpg',
                //     path: '/cust/asmt/bind_cust',
                //     name: '测评报告',
                // },
                {
                    img: '/static/images/cust/jg1_0.jpg',
                    path: '/asmt/index',
                    name: '心理测评',
                },
                {
                    img: '/static/images/cust/jg1_1.jpg',
                    path: '/mod/resource_portal',
                    name: '心灵驿站',
                },
            ],


            jg2Arr: [],

            jg2Arr_21: [
                {
                    icon: '&#xe601;',
                    path: '/cust/spt/ihys_guest_portal',
                    name: '心灵树洞',
                    color: '#e16c00',
                },
                {
                    icon: '&#xe697;',
                    path: '/cust/spt/bbs_portal',
                    name: '同行社区',
                    color: '#21b3ff',
                },
                // {
                //     icon: '&#xe88d;',
                //     path: '/cust/spt/activity_portal',
                //     name: '活动日历',
                //     color: '#409eff',
                // },
                {
                    icon: '&#xe60c;',
                    path: '/cust/spt/consult_guest_portal',
                    name: '预约咨询',
                    color: '#009c77',
                },
                {
                    icon: '&#xe665;',
                    path: '/cust/spt/mood_portal',
                    name: '心情日记',
                    color: '#9765e3',
                },
                {
                    icon: '&#xe604;',
                    path: '/cust/spt/ai_chat',
                    name: 'AI问答',
                    color: '#d4237a',
                },
            ],
            jg2Arr_31: [
                {
                    icon: '&#xe601;',
                    path: '/cust/spt/ihys_guest_portal',
                    name: '心灵树洞',
                    color: '#e16c00',
                },
                {
                    icon: '&#xe60c;',
                    path: '/cust/spt/consult_guest_portal',
                    name: '预约咨询',
                    color: '#009c77',
                },
                {
                    icon: '&#xe88d;',
                    path: '/cust/spt/activity_portal',
                    name: '活动日历',
                    color: '#409eff',
                },
                {
                    icon: '&#xe642;',
                    path: '/cust/visit/warn_visit',
                    name: '评估工作',
                    color: '#e16c00',
                },
                {
                    icon: '&#xe63c;',
                    key: 'work_spt',
                    path: '/cust/spt/spt_portal',
                    name: '工作台',
                    color: '#009c77',
                },
                {
                    icon: '&#xe697;',
                    path: '/cust/spt/bbs_portal',
                    name: '同行社区',
                    color: '#21b3ff',
                },
                {
                    icon: '&#x10185;',
                    path: '/cust/asmt/bind_cust',
                    name: '绑定学生',
                    color: '#fb4634',
                },
                {
                    icon: '&#xe665;',
                    path: '/cust/spt/mood_portal',
                    name: '心情日记',
                    color: '#9765e3',
                },
            ],

            docList: [],

            sptPendingCount: 0,

            centerDialogTit: '',
            centerDialogWidth: '660px',
            dialogClass: '',
            centerDialogFs: false,
            centerDialogVisible: false,
            centerComp: {},
        };
    },
    methods: {
        navTo: function (path) {
            if (path) {
                this.$router.push(path);
            } else {
                this.$message.info('敬请期待');
            }
        },

        getDocList: function () {
            let _this = this;
            this.req('/home_doc_list', {}, function (data) {
                if (data.success) {
                    _this.docList = data.obj;
                } else {
                    _this.$message.error(data.message);
                }
            })
        },
        navDocDetail: function (n) {
            this.$router.push('/mod/resource_detail?id=' + n.id);
        },
        checkSptPendingCount: function() {
            let count = sessionStorage.getItem('sptPendingCount');
            this.sptPendingCount = count ? parseInt(count) : 0;
        },
        guestOverConsultOd: function () {
            let _this = this;
            let param = {
                statusList: [1,2],
                hgType: 'guest',
            };

            this.req('/consult_order_list', param, function (data) {
                if (data.success) {
                    _this.unfinishedOrderCount = data.obj.length;
                    if (data.obj.length > 0) {
                        _this.unfinishedOrder = data.obj[0];
                    }
                } else {
                    _this.$message.error(data.message);
                }
            }, "post", false);
        },
    },
    mounted: function () {
        this.$nextTick(function () {
            this.uid = sessionStorage.getItem("uid");
            this.type = sessionStorage.getItem("type");

            if (this.type == 21) {
                this.jg1Arr = this.jg1Arr_21;
                this.jg2Arr = this.jg2Arr_21;
            } else if (this.type == 31) {
                this.jg1Arr = this.jg1Arr_31;
                this.jg2Arr = this.jg2Arr_31;
                let bizCount = sessionStorage.getItem("bizCount");
                if (!bizCount || bizCount === '0') {
                    this.jg2Arr = this.jg2Arr.filter(item => item.key !== 'work_spt');
                }
            }

            this.getDocList();
            this.checkSptPendingCount();
            this.lib.checkPendingCount(function(count) {
                _this.sptPendingCount = count;
            });
            this.guestOverConsultOd();

            let _this = this;
            this.pendingTimer = setInterval(function() {
                _this.checkSptPendingCount();
                _this.guestOverConsultOd();
            }, 60000);
        });
    },
    beforeDestroy: function () {
        if (this.pendingTimer) {
            clearInterval(this.pendingTimer);
        }
    },
};
</script>
<style scoped>
.sysName {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    padding-top: 20px;
    height: 80px;
    color: #fff;
    background: linear-gradient(to bottom, #077cf5, #077cf5cc);
}
.bannerWrap {
    /* padding: 15px; */
    box-sizing: border-box;
}
.bannerItem {
    height: 100%;
    background-size: cover;
    background-position: center;
    border-end-end-radius: 20px;
}
.noticeBar {
    display: flex;
    padding: 10px 15px;
    gap: 10px;
    align-items: center;
    background-color: #077cf522;
    border-radius: 5px;
}
.noticeBar i {
    width: 20px;
    line-height: 20px;
    text-align: center;
    color: #077cf5;
    font-weight: bold;
    height: 20px;
    font-size: 18px;
}
.noticeTxt {
    flex: 1;
}
.orderNoticeBar {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    margin-bottom: 10px;
    background: #fff;
    border-radius: 10px;
    border: 2px solid #ff6b35;
    box-shadow: 0 2px 12px rgba(255, 107, 53, 0.15);
    cursor: pointer;
}
.orderAvatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    margin-right: 12px;
}
.orderNoticeLeft {
    flex: 1;
}
.orderStatus {
    font-size: 15px;
    font-weight: bold;
    color: #333;
    margin-bottom: 3px;
    display: flex;
    align-items: center;
    gap: 6px;
}
.statusDot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}
.orderInfo {
    font-size: 12px;
    color: #888;
}
.orderNoticeRight {
    display: flex;
    align-items: center;
    gap: 8px;
}
.orderBadge {
    font-size: 11px;
    background: #fff1e6;
    color: #ff6b35;
    padding: 3px 8px;
    border-radius: 10px;
    font-weight: 500;
}
.orderNoticeRight i {
    font-size: 16px;
    color: #ccc;
}

.jg1Box {
    display: flex;
    gap: 10px;
    margin-top: 15px;
}
.jr1b {
    flex: 1;
    border-radius: 10px;
    height: 90px;
    background-color: #077cf5;
    background-size: cover;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.jr1bTxt {
    text-align: center;
    line-height: 90px;
    color: #fff;
    font-size: 20px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.jg2Box {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.jg2Item {
    /*width: calc(25% - 10px);*/
    /* flex: 1; */
    margin: 10px 5px;
    padding: 10px 0;
    cursor: pointer;
    min-width: calc(25% - 10px);
}
.jg2IconWrap {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    margin: auto;
    box-sizing: border-box;
    text-align: center;
    line-height: 55px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    position: relative;
}
.pendingBadge {
    position: absolute;
    top: -2px;
    right: -2px;
    width: 12px;
    height: 12px;
    background-color: #f56c6c;
    border-radius: 50%;
    border: 2px solid #fff;
}
.jg2Icon {
    font-size: 28px;
    margin: auto;
}
.jg2Name {
    text-align: center;
    margin-top: 5px;
    font-size: 14px;
}

.docBox {
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.02);
    padding: 15px;
}
.docTop {
    display: flex;
    height: 30px;
    line-height: 30px;
}
.dtTxt {
    flex: 1;
    font-weight: bold;
}
.dtMore {
    width: 80px;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #077cf5;
    cursor: pointer;
}
.dtMore .iconfont {
    color: #077cf5;
}
.dtItem {
    display: flex;
    gap: 10px;
    margin-top: 15px;
}
.dtCover {
    width: 128px;
    height: 72px;
    border-radius: 8px;
}
.dtInfo {
    flex: 1;
}
.dtTit {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
    height: 42px;
    font-size: 14px;
    margin-bottom: 10px;
}
.dtTime {
    color: #888;
    font-size: 13px;
}

@media (max-width: 770px) {
    /* .asmtItem {
        width: 100%;
        height: auto;
        float: none;
        margin-right: 0px;
    }
    .asmtBox {
        padding: 30px 30px;
    } */
}
</style>


// WEBPACK FOOTER //
// src/components/cust/index.vue